/* eslint-disable no-nested-ternary*/
/* eslint-disable jam3/no-sanitizer-with-danger */

import React, { useEffect, useState } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { Link } from 'react-router-dom'
import styles from './View.Style';
import * as pages from 'common_constants/Pages'
import NavigationService from 'support/navigation/NavigationService'
import noDraftIdeasImg from 'img/no_draft_idea.png'
import InvestorsImg from 'img/imgs/investors.svg';
import { Container, Stepper, Step, StepLabel, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams, useLocation, useHistory } from 'react-router-dom'
import { safeJSONStringify } from 'services/RequestUtils';
import Loading from 'components_newui/Loading';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import CommonDialog from 'components_newui/dialogs/CommonDialog';
import { IdeaDetails } from './IdeaDetails';
import { IdeaGenerateForm } from './IdeaGeneratedForm';
import { IdeaConfirmAndSubmit } from './ideaConfirmAndSubmit';
import CustomButton from 'components_newui/customButton/CustomButton';

const MAX_FILE_SIZE_MB = 10;




const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  title: {
    fontFamily: 'VodafoneRg-bold',
    fontSize: '2.125rem',
    margin: '1rem 0 2rem 0',
    textAlign: 'left',
    paddingTop: '1rem',
    color: '#333',
  },
  titleSub: {
    fontFamily: 'VodafoneRg-bold',
    fontSize: '1.5rem',
    margin: '1rem 0 1rem 0',
    textAlign: 'center',
    paddingTop: '1rem',
    color: '#333',
  },
  summary: {
    fontFamily: 'VodafoneRg-Regular',
    fontSize: '1.125rem',
    lineHeight: '1.5',
    margin: '1rem 0 1rem 0',
    textAlign: 'left',
    paddingTop: '1rem',
    color: '#333',
  },
  backButton: { marginRight: theme.spacing(1) },
  instructions: { marginTop: theme.spacing(1), marginBottom: theme.spacing(1) },
  instructions1: { marginTop: theme.spacing(1), marginBottom: theme.spacing(3) },
}));


const defaultValues = {
  challengeKey: '',
  ideaKey: '',
  market: '',
  businessUnit: '',
  title: '',
  summary: '',
  documentsKey: undefined,
  coverPhoto: [],
  addInfo: '',
  ideaTemplate: null,
  ideaTemplateAnswers: null,
  termsAndConditions: true,
};


const stepConfig = [
  {
    label: 'Idea Details',
    component: IdeaDetails,
    validationSchema: yup.object({
      title: yup.string()
        .min(3, 'Minimum 3 characters')
        .max(100, 'Maximum 100 characters')
        .required()
        .trim()
        // .matches(
        //   /^[a-zA-Z0-9_ #!?]*$/,
        //   'Only letters, numbers, spaces, underscore (_), hash (#), exclamation (!), and question mark (?) are allowed'
        // ),
        .matches(
          /^[a-zA-Z0-9_ #!?|]*$/,
          'Only letters, numbers, spaces, underscore (_), hash (#), exclamation (!), question mark (?), and pipe (|) are allowed'
        ),
      summary: yup.string().required().trim(),
      market: yup.string().required(),
      businessUnit: yup.string().required(),
      coverPhoto: yup.array()
        .of(
          yup
            .mixed()
            .test(
              'fileSize',
              'Image must be less than 10 MB',
              (value) => {
                if (!value) return false;

                // Check if it's a new file
                if (value.file && typeof value.file.size === 'number') {
                  return value.file.size / (1024 * 1024) <= 10;
                }

                // Check if it's an existing image with size
                if (typeof value.size === 'number' && value.size > 0) {
                  // If size is in KB, convert to bytes
                  const sizeInBytes = value.size < 10000 ? value.size * 1024 : value.size;
                  return sizeInBytes / (1024 * 1024) <= 10;
                }

                // If no valid size info, skip validation
                return true;
              }
            )
        )
        .min(1, 'At least one image is required')
        .required('Cover photo is required')


    }),




  },
  {
    label: 'Tell Us More',
    component: IdeaGenerateForm,
    validationSchema: yup.object({
      // templateIdea: yup.object().required(),
    }),
  },
  {
    label: 'Confirm & Submit',
    component: IdeaConfirmAndSubmit,
    validationSchema: yup.object({
      // templateIdea: yup.object().required(),
    }),
  },
  // {
  //   label: 'Challenge Summary',
  //   component: ChallengePreview,
  //   validationSchema: yup.object(),
  // },
];



const IdeaSubmitEdit = (props) => {


  const { navigateToAccessDenied,isAdmin, isEvaluator, isOwner, myEmail: loginEmail, getInnovateIdeaImageLoading, getInnovateIdeaImage, InnovateIdeaStatus, postInnovateCreateIdeaPublishFn, getInnovateCreateIdeaPublishLoading, getInnovateIdeaIdDetail, getInnovateIdeaIdDetailIsLoading, getIdeaInnovateDetailFn, getInnovateCreateIdeaEditLoading, getInnovateCreateIdeaDraftData, getInnovateIdeaDocumentUpload = [], postInnovateCreateIdeaEditFn, getInnovateCreateIdeaDraftLoading, getInnovateIdeaDraftID, postInnovateCreateIdeaDraftFn, getInnovateIdeaTemplateIdJsonFn, getInnovateIdeaTemplateIdJsonLoading, getInnovateIdeaTemplateIdJson } = props || {}
  // const idea = getInnovateIdeaIdDetail?.idea || {}  
  const location = useLocation();
  const history = useHistory();
  const challengeSelectedData = location.state?.challenge;
  const { challengeOrganizerEmailList,isIdeaTermAccepted, id, visits, title: ideaTitle, status: currentIdeaStatus, textWithoutTags, published, ownerPhoto, ownerName, owner: ownerEmail, businessUnit, market, additionalInfo, isInnovate, images, ideaTemplateAnswers, ideaTemplate, challenged, challenge: tagedChallenge } = getInnovateIdeaIdDetail?.ideaForInnovater || {}
  const { title: challengeTitle, id: challengeKeyID, termAndCondition, desc = '', ends:challengeEndDate } = tagedChallenge || {}
  const arrOfObjIdeaTemplate = ideaTemplate?.value
  const { id: draftIdeaKey } = getInnovateIdeaDraftID || {}
  const { idea: listReponseDraftID } = getInnovateCreateIdeaDraftData
  const { id: ideaId } = useParams();
  const classes = useStyles();
  const [getAnswerFromIdeaToDynamicForm, setGetDatafromDynamicFormIdea] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [isValidField, setIsValidField] = useState(false);
  const [isValidFormDynamicField, setIsValidFormDynamicField] = useState(false);
  // const [dialogOpenForChallengeTnc, setDialogOpenForChallengeTnc] = useState(false);
  const currentStep = stepConfig[activeStep];

  const copyArrgetInnovateIdeaDocumentUpload = getInnovateIdeaDocumentUpload || []
  const ideaTemplateId = getInnovateIdeaIdDetail?.ideaForInnovater?.challenge?.ideaTemplateId
  const ideaIsOwner = loginEmail === ownerEmail

const isOrganizer = (challengeOrganizerEmailList || []).some(
  email => email.toLowerCase() === loginEmail?.toLowerCase()
);

const hasEditPermission = isAdmin || isOrganizer || ideaIsOwner;



  // 2) end-date based finish (challengeEndDate is a string like "Feb 25, 2026, 5:00:00 PM")
// const endTime = challengeEndDate ? new Date(challengeEndDate).getTime() : NaN;
// const isFinishedByEndDate = Number.isFinite(endTime) && Date.now() > endTime;

  // const ideaTemplateId = 5260063627280384

  useEffect(() => {
    if (ideaTemplateId) {
      getInnovateIdeaTemplateIdJsonFn?.(ideaTemplateId)
    }
  }, [ideaTemplateId]);


  useEffect(() => {
    if (ideaId) {
      getIdeaInnovateDetailFn?.(ideaId)
    }
  }, [ideaId]);

  const methods = useForm({
    defaultValues,
    resolver: yupResolver(currentStep?.validationSchema),
    mode: 'onChange',
  });

  const { handleSubmit, trigger, getValues, setValue, reset } = methods;
  // console.log('isValidFormDynamicField on next button click', isValidFormDynamicField)

  const transformIdeaDataToFormValues = (responseDataGetIdea) => {
    const responseData = responseDataGetIdea?.ideaForInnovater
    const responseDataDocu = getInnovateIdeaIdDetail?.documents

    // console.log("update---0-0-0-0-0--0", responseDataGetIdea, 'diff', responseData)
    return ({
      challengeKey: responseData?.challenge?.id ?? null,
      ideaKey: responseData?.id ?? null,
      market: responseData?.market ?? '',
      businessUnit: responseData?.businessUnit ?? '',
      title: responseData?.title ?? '',
      summary: responseData?.textWithoutTags ?? '',
      documentsKey: responseDataDocu,
      documents: responseDataDocu,
      coverPhoto: responseData?.images,
      addInfo: responseData?.additionalInfo ?? '',
      ideaTemplate: responseData?.ideaTemplate?.value ?? null,
      ideaTemplateAnswers: responseData?.ideaTemplateAnswers?.value,
      isIdeaTermAccepted: responseData?.isIdeaTermAccepted ?? false
    });

  }

  // const onHandleViewChallengeTnc = ()=>{
  //   setDialogOpenForChallengeTnc((prev)=>!prev)
  // }

  // const items = getInnovateIdeaIdDetail?.idea
  // const items = ideaDummy

  useEffect(() => {
    if (getInnovateIdeaIdDetail) {
      const transformed = transformIdeaDataToFormValues(getInnovateIdeaIdDetail);
      reset(transformed);
    }
  }, [reset,getInnovateIdeaIdDetail]);



  // const handleIdeaTemplateIJson = async () => {
  //   const isValidId = Number(ideaTemplateId);
  //   if (!isValidId) return;

  //   try {
  //     const isValid = await trigger();
  //     setIsValidField(isValid)
  //     await getInnovateIdeaTemplateIdJsonFn(ideaTemplateId);

  //     // Start polling every 300ms to check if loading is done
  //     // const pollInterval = setInterval(async () => {
  //     //   if (!!getInnovateIdeaTemplateIdJsonLoading) {
  //     //     clearInterval(pollInterval); // Stop polling

  //     //     const isValid = await trigger();
  //     //     if (isValid) {
  //     //       setActiveStep(prev => prev + 1);
  //     //     }
  //     //   }
  //     // }, 300);


  //   } catch (error) {
  //     console.error('Error fetching idea template JSON:', error);
  //   }
  // };



  const nextStepsAfterFormSubmit = async () => {
    const isValid = await trigger();
    // console.log("Validation result:", isValid);

    if (isValid) {
      setIsValidFormDynamicField(true);
      // Proceed to next step
    } else {
      setIsValidFormDynamicField(false);
    }
  };


  // const nextStepsAfterFormSubmit = async ()=>{
  //     const isValid = await trigger();
  //     setIsValidFormDynamicField(isValid)

  // }


  //Start polling approach to check api response success check based on value using useEffect
  useEffect(() => {
    const checkAndProceed = async () => {
      // console.log("checkAndProceed = getInnovateIdeaTemplateIdJsonLoading", !getInnovateIdeaTemplateIdJsonLoading, getInnovateIdeaTemplateIdJsonLoading)
      if (!getInnovateIdeaTemplateIdJsonLoading) {
        if (isValidField) {
          setActiveStep(prev => prev + 1);
        }
      }
    };

    checkAndProceed();
  }, [getInnovateIdeaTemplateIdJsonLoading]);


  //Start polling approach to check api response success check based on value using useEffect
  useEffect(() => {
    const checkAndProceedFormSteps = async () => {
      if (isValidFormDynamicField) {
        setActiveStep(prev => prev + 1);
      }
    };
    checkAndProceedFormSteps();
  }, [isValidFormDynamicField]);


  const childToParentformDatatoUpdate = (data) => {
    setGetDatafromDynamicFormIdea(data)
  }


  useEffect(() => {
    if (getInnovateIdeaIdDetailIsLoading) return;
    if (!hasEditPermission) {
      history.push(navigateToAccessDenied());
    }
  }, [
    getInnovateIdeaIdDetailIsLoading,
    hasEditPermission,
    history,
  ]);


  //before submit idea form data value marge into json
  function isNonEmptyArray(variable) {
    return Array.isArray(variable) && variable.length > 0;
  }


  let mergedQuestionAndAnswerJsonData
  if (isNonEmptyArray(getAnswerFromIdeaToDynamicForm)) {
    mergedQuestionAndAnswerJsonData = getInnovateIdeaTemplateIdJson.map(item => {
      const match = getAnswerFromIdeaToDynamicForm.find(o => o.id === item.id);
      // console.log("value merge:", match)
      return {
        ...item,
        value: match ? match.value : item.value
      };
    });
  }

  //   let mergedQuestionAndAnswerJsonData
  // if(isNonEmptyArray(getAnswerFromIdeaToDynamicForm)){
  //   getInnovateIdeaTemplateIdJson.map(item => {
  //     const match = getAnswerFromIdeaToDynamicForm.find(o => o.id === item.id);
  //     // console.log("value merge:", match)
  //     return {
  //       ...item,
  //       value: match ? match.value : item.value
  //     };
  //   });
  // }

  // console.log("getInnovateIdeaTemplateIdJson", getInnovateIdeaTemplateIdJson)


  const handleNext = async () => {
    const isValid = await trigger();
    if (isValid) setActiveStep((prev) => prev + 1);
    window.scrollTo(0, 0)
  };

  const handleBack = () => {
    setIsValidFormDynamicField(false);
    setActiveStep((prev) => prev - 1);
    window.scrollTo(0, 0)
  }

  const handleReset = () => {
    reset(defaultValues);
    setActiveStep(0);
  };




  // // submit idea
  const handleSubmitEditIdea = async (formparams) => {

    try {

      const allData = methods.getValues();

      // const getnameImage = getInnovateIdeaImage?.name || images[0]?.name;
       const getnameImage = getInnovateIdeaImage?.name?.trim() || images?.[0]?.name?.trim() || "";

       if (!getnameImage) {
         methods.setError("coverPhoto", {
           type: "required",
           message: "Cover photo is required.",
         });
         console.warn("Save blocked: Please Upload the image, it seems to be no uploaded correctly.");
         return;
       }

      const editIdeaFormData = {
        ...allData,
        ideaTemplateAnswers: safeJSONStringify(getAnswerFromIdeaToDynamicForm),
        coverPhoto: getnameImage,
      };



      // Check conditions before proceeding
      // if (
      //   Array.isArray(getAnswerFromIdeaToDynamicForm) &&
      //   getAnswerFromIdeaToDynamicForm.length === 0 
      //   // &&
      //   // challengeKeyID === ''
      // ) {
      //   console.warn("submit not saved: Empty answers and missing challengeKeyID.");
      //   return;
      // }

      // await postInnovateCreateIdeaDraftFn(allDraftIdea);
      // if(listReponseDraftID?.status === "DRAFT"){
      await postInnovateCreateIdeaEditFn(editIdeaFormData);
      // }
      console.log("submit saved successfully.");
    } catch (error) {
      console.error("Error saving submit:", error);
      // Optionally show a user-friendly error message
      // e.g., toast.error("Failed to save draft. Please try again.");
    }
  }



  // submit idea
  const handleSubmitIdea = async () => {
    try {
      const allData = methods.getValues();
      // const getnameImage = getInnovateIdeaImage?.name || images[0]?.name;

      const getnameImage = getInnovateIdeaImage?.name?.trim() || images?.[0]?.name?.trim() || "";

      if (!getnameImage) {
        methods.setError("coverPhoto", {
          type: "required",
          message: "Cover photo is required.",
        });
        console.warn("Submit blocked: Please Upload the image, it seems to be no uploaded correctly.");
        return;
      }

      const allDraftIdea = {
        ...allData,
        ideaKey: ideaId,
        challengeKey: challengeKeyID,
        documentsKey: copyArrgetInnovateIdeaDocumentUpload || [],
        ideaTemplate: JSON?.stringify(mergedQuestionAndAnswerJsonData),
        ideaTemplateAnswers: safeJSONStringify(getAnswerFromIdeaToDynamicForm),
        coverPhoto: getnameImage
      };

      // Check conditions before proceeding
      if (
        Array.isArray(getAnswerFromIdeaToDynamicForm) &&
        getAnswerFromIdeaToDynamicForm.length === 0 &&
        challengeKeyID === ''
      ) {
        console.warn("submit not saved: Empty answers and missing challengeKeyID.");
        return;
      }

      // await postInnovateCreateIdeaDraftFn(allDraftIdea);
      // if(listReponseDraftID?.status === "DRAFT"){
      await postInnovateCreateIdeaPublishFn(allDraftIdea);
      // }
      console.log("submit  successfully.");
    } catch (error) {
      console.error("Error saving submit:", error);
      // Optionally show a user-friendly error message
      // e.g., toast.error("Failed to save draft. Please try again.");
    }
  }




  const StepComponent = currentStep?.component;

  let buttonContent;

  if (activeStep === 0) {
    buttonContent = (
      // <Button
      //   type="button"
      //   // onClick={handleIdeaTemplateIJson}
      //   variant="contained"
      //   color="primary"
      //   disabled={getInnovateIdeaTemplateIdJsonLoading}
      // >
      //   {getInnovateIdeaTemplateIdJsonLoading ? 'Loading...' : 'Next'}
      // </Button>
      <CustomButton
        type="button"
        onClick={handleNext}
        disabled={getInnovateIdeaImageLoading}
        variant="contained"
        color="primary"
      >
        Next
      </CustomButton>
    );
  }
  else if (activeStep === 1) {
    buttonContent = null
  }
  else {
    buttonContent = (
      <CustomButton
        type="button"
        onClick={handleNext}
        variant="contained"
        color="primary"
      >
        Next
      </CustomButton>
    );
  }


  const valuaget = methods.getValues();
  const enablesubmitbutton = isIdeaTermAccepted ? '' : !(valuaget?.tncIdea)

  const isOwnerInnovate = ownerEmail === loginEmail
  // console.log("🚀 ~ isOwnerInnovate:", isOwnerInnovate)

  if (getInnovateIdeaIdDetailIsLoading) {
    // return 'Edit Idea content Loading...'
    return <Loading />
  }

  return (
    <Container>

      <h2 className={classes.title}> Edit Idea - {ideaTitle}</h2>
      <div className={classes.root}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {stepConfig.map((step) => (
            <Step key={step.label}>
              <StepLabel>{step.label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <div className={classes.instructions}>  <h3 className={classes.titleSub}>  Challenge tagged - {challengeTitle}</h3> </div>
        
        {activeStep === 0 && <div className={classes.instructions}> <h3 className={classes.summary}>Challenge description</h3>  <div dangerouslySetInnerHTML={{ __html: desc }} /> </div>}

        {activeStep === stepConfig.length ? (
          <div>
            <p className={classes.instructions}>All steps completed</p>
            <Button onClick={handleReset}>Reset</Button>
          </div>
        ) : (
          <FormProvider {...methods}>
            <div className='formlevel' >
              <div className={classes.instructions}>
                <StepComponent
                  {...props}
                  formData={getValues()}
                  isAdmin={isAdmin}
                  isOwnerInnovate={ownerEmail === loginEmail}
                  isEvaluator={isEvaluator}
                  nextStepsAfterFormSubmit={nextStepsAfterFormSubmit}
                  getAnswerFromIdeaToDynamicForm={getAnswerFromIdeaToDynamicForm}
                  handleFormChange={childToParentformDatatoUpdate}
                  termAndCondition={termAndCondition} />
              </div>

              <div className={classes.instructions1}>
                <CustomButton
                  type='button'
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className={classes.backButton}
                >
                  Back
                </CustomButton>

                {activeStep === stepConfig.length - 1 ? (
                  <>
                    {/* <Button
                    onClick={onHandleViewChallengeTnc}
                    className={classes.backButton}
                    variant="contained"
                    color="primary"
                    disabled={getInnovateCreateIdeaDraftLoading}
                  >
                   View Challenge T&C
                  </Button> */}

                    <CustomButton
                    type='button'
                    styles={{ marginRight: '8px' }}
                      onClick={handleSubmitEditIdea}
                      variant="contained"
                      disabled={getInnovateCreateIdeaEditLoading }
                      color="primary">
                      Save Idea
                    </CustomButton>

                    {/* {console.log("currentIdeaStatus---edit idea", currentIdeaStatus)} */}
                    {currentIdeaStatus === "DRAFT" ?
                       <CustomButton
                       type='button'
                        styles={{ paddingLeft: '8px' }}
                        onClick={handleSubmitIdea}
                        variant="contained"
                        disabled={getInnovateCreateIdeaPublishLoading || enablesubmitbutton}
                        color="primary">
                        Submit Idea
                      </CustomButton>
                      : null}
                      
                    {/* <Button type="submit" onSubmit={handleSubmit(onSubmitAllForm)} variant="contained" color="primary">
                    Submit Idea
                  </Button> */}
                  </>
                ) : (buttonContent)

                }
              </div>
            </div>
          </FormProvider>
        )}
      </div>

    </Container>
  );
}


export default withStyles(styles)(IdeaSubmitEdit)
